import { BinaryFile } from "@/components/sleep_checkup_v1/Types";
import { facilityAxios as axios } from "@/utils/axios";
import { AxiosResponse } from "axios";

/**
 * バイナリファイル一覧取得APIのレスポンス
 */
export interface GetBinaryFilesResponse {
  count: number;
  results: BinaryFile[];
}

/**
 * バイナリファイル一覧取得APIを呼び出し、APIのレスポンスを返す
 * @param limit 取得する件数
 * @param offset 開始位置（スキップする件数）
 * @returns APIのレスポンス
 */
export function getBinaryFiles(
  limit: number = 10,
  offset: number = 0
): Promise<AxiosResponse<GetBinaryFilesResponse>> {
  return axios.get("/api/facility/binary_files/", {
    params: {
      limit: limit,
      offset: offset,
    },
  });
}

/**
 * バイナリファイルアップロード初期化APIを呼び出し、APIのレスポンスを返す
 * @param fileName ファイル名
 * @param fileSize ファイルサイズ
 * @param totalChunks 総チャンク数
 * @returns APIのレスポンス（アップロードID含む）
 */
export function initializeBinaryFileUpload(
  fileName: string,
  fileSize: number,
  totalChunks: number,
  signal?: AbortSignal
): Promise<AxiosResponse<BinaryFile>> {
  return axios.post(
    "/api/facility/binary_files/initialize/",
    {
      filename: fileName,
      file_size: fileSize,
      total_chunks: totalChunks,
    },
    { signal }
  );
}

/**
 * バイナリファイルチャンクアップロードAPIを呼び出し、APIのレスポンスを返す
 * @param fileId アップロードID
 * @param chunkIndex チャンクのインデックス
 * @param chunk チャンクデータ
 * @returns APIのレスポンス
 */
export function uploadBinaryFileChunk(
  fileId: string,
  chunkIndex: number,
  chunk: Blob,
  signal?: AbortSignal
): Promise<AxiosResponse<void>> {
  const formData = new FormData();
  formData.append("chunk_data", chunk);
  formData.append("chunk_index", chunkIndex.toString());

  return axios.post(
    `/api/facility/binary_files/${fileId}/upload_chunk/`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      signal,
    }
  );
}

/**
 * バイナリファイルアップロード完了APIを呼び出し、APIのレスポンスを返す
 * @param fileId アップロードID
 * @param cancel trueの場合、アップロードをキャンセル
 * @returns APIのレスポンス
 */
export function completeBinaryFileUpload(
  fileId: string,
  cancel: boolean = false
): Promise<AxiosResponse<BinaryFile>> {
  return axios.post(`/api/facility/binary_files/${fileId}/complete_upload/`, {
    cancel,
  });
}
